<!-- Center canvas: typed into directly (read-only in View/Proof/Annotate) -->
<div class="cr-sub-card" *ngIf="isPreview">
  <span
    class="cr-sub-value"
    [appInlineEdit]="block.variables?.Subject ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert Subject here"
    (inlineEditChange)="onChange($event)"
  ></span>
  <span class="cr-sub-badge">Subject</span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-sub-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.Subject ?? ''"
    (handleOnChange)="onChange($event)"
    [placeholder]="subjectPlaceholder"
    [maxLength]="4000"
    variable="Subject"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
